import React from "react";
import ReactDOM from "react-dom/client";
import "./appTailwindStyles.css";
import "./index.css";
import App from "./App";
import { ToastProvider } from "./context/ToastContext";
import { ThemeProvider } from "@mui/material/styles";
import { LoadingProvider } from "./context/LoadingContext";
import theme from "./shared/utils/theme";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ToastProvider>
      <ThemeProvider theme={theme}>
        <LoadingProvider>
          <App />
        </LoadingProvider>
      </ThemeProvider>
    </ToastProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
